<template>
  <div class="post-index-header-container">
    <div class="container">
      <div class="grid">
        <div class="g-col-16 g-start-900-2 g-col-900-15">
          <div class="post-index-header">
            <div class="post-index-header-lc">
              <h2 class="h2" v-html="headline" data-animation="fade-in-up"></h2>
              <div
                class="post-index-header-desc"
                v-html="description"
                data-animation="fade-in"
              ></div>
            </div>
            <div class="post-index-header-rc" data-animation="fade-in-up">
              <post-filters
                :filters="filters"
                :posttype="posttype"
                @update-terms="updateTerms"
                @reset-terms="resetTerms"
                @update-search="updateSearch"
                @update-sort="updateSort"
              ></post-filters>
              <ul class="bare-list post-sns">
                <li>
                  <a :href="linkedin.url" :target="linkedin.target" class="linkedin"
                    ><span class="sr-only">linkedin</span></a
                  >
                </li>
                <li>
                  <a :href="instagram.url" :target="instagram.target" class="instagram"
                    ><span class="sr-only">instagram</span></a
                  >
                </li>
                <li>
                  <a :href="youtube.url" :target="youtube.target" class="youtube"
                    ><span class="sr-only">youtube</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container post-index-body">
    <div class="grid">
      <div class="g-col-16 g-start-900-2 g-col-900-14">
        <post-grid :posts="posts" class_name="post-index-grid"></post-grid>

        <!-- <div class="post-index-observer"></div> -->

        <div class="post-index-dashboard">
          <button
            class="btn"
            @click="getLoadMorePosts"
            v-if="page < totalpages"
          >
            Load More
          </button>
          <div v-if="api_call_status === 1" class="post-index-loader label-sm">
            <svg
              version="1.1"
              id="loader-1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="40px"
              height="40px"
              viewBox="0 0 50 50"
              style="enable-background: new 0 0 50 50"
              xml:space="preserve"
            >
              <path
                fill="#0032ff"
                d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                transform="rotate(23.7492 25 25)"
              >
                <animateTransform
                  attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animateTransform>
              </path>
            </svg>
          </div>
          <div
            v-if="posts.list.length === 0 && api_call_status === 0"
            class="post-index-no-result"
          >
            NO RESULTS FOUND
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import PostFilters from "./PostFilters.vue";
import PostGrid from "./PostGrid.vue";

export default {
  components: {
    PostFilters,
    PostGrid,
  },
  props: ["cms"],
  setup(props) {
    const pageID = document.querySelector("body").dataset.id;

    let filters = reactive({ list: [] });
    let posts = reactive({ list: [] });
    let page = ref(1);
    let totalpages = ref(-1);
    let posttype = ref("");
    let headline = ref("");
    let description = ref("");
    let linkedin = ref("");
    let instagram = ref("");
    let youtube = ref("");
    let q_term = "";
    let q_term_id = "";
    let q_tax = "";
    let q_search = "";
    let q_order = "DESC";
    let q_orderby = "date"; //title menu_order
    let ppp = 8;
    let observerTarget;
    let isLoadCompleted = false;
    let api_call_status = ref(1); //1 = calling api, 0 = done
    const parsedURL = new URL(window.location.href);
    let parse_cms;
    let main;

    onMounted(() => {
      observerTarget = document.querySelector(".post-index-observer");
      main = document.querySelector("main#content");

      history.pushState(
        {},
        "",
        `${window.location.origin}${window.location.pathname}`
      );

      window.addEventListener("popstate", (event) => {
        let temp_selected_term = "";

        if (event.state && event.state.term_id) {
          // filters.list
          filters.list.forEach((item) => {
            item.terms.forEach((term) => {
              if (event.state.term_id === term.term_id.toString()) {
                term.selected = true;
                q_term += `&${item.taxonomy}=${term.term_id.toString()}`;
                item.selected_term = term.name;
                temp_selected_term = term.name;
              } else {
                term.selected = false;
                main.querySelector(`#${term.slug}`).checked = false;
              }
            });
          });

          getPosts(false, true);

          // ui
          main.querySelector(".post-filter-trigger").classList.add("filtered");
          main.querySelector(".post-filter-trigger .label").innerHTML =
            temp_selected_term;
          main
            .querySelector(".post-filter-clear-trigger")
            .classList.add("show");
        } else {
          // filters.list
          filters.list.forEach((item) => {
            item.terms.forEach((term) => {
              term.selected = false;
              main.querySelector(`#${term.slug}`).checked = false;
            });
          });

          // var for getPosts();
          q_term = "";
          getPosts(false, true);

          // ui
          main
            .querySelector(".post-filter-trigger")
            .classList.remove("filtered");
          main.querySelector(".post-filter-trigger .label").innerHTML =
            "Filter by";
          main
            .querySelector(".post-filter-clear-trigger")
            .classList.remove("show");
        }
      });

      initialCall();
    });

    /**
     * Set Intersection Observer
     */
    // function setIntersectionObserver() {
    //   let observer = new IntersectionObserver((entries) => {
    //     const entry = entries[0];
    //     if (entry.isIntersecting && !isLoadCompleted) {
    //       getLoadMorePosts();
    //     }
    //   });

    //   observer.observe(observerTarget);
    // }

    /**
     * Fetch API
     */
    function getData(url) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then((response) => {
            return response.json();
          })
          .then((data) => resolve(data))
          .catch((error) => reject(error));
      });
    }

    /**
     * Initial Call
     */
    const initialCall = () => {
      parse_cms = JSON.parse(props.cms);
      // console.log(parse_cms);

      // set filters
      filters.list = parse_cms.filters;
      posttype.value = parse_cms.post_type;
      headline.value = parse_cms.lam.headline;
      description.value = parse_cms.lam.description;
      linkedin.value = parse_cms.lam.sns.linkedin;
      instagram.value = parse_cms.lam.sns.instagram;
      youtube.value = parse_cms.lam.sns.youtube;

      let temp_selected_term = "";
      // check URL params
      // parsedURL.search i.e ?article-series=18
      if (parsedURL.search.length > 0) {
        filters.list.forEach((item) => {
          const paramTerm = parsedURL.searchParams.get(item.taxonomy);

          if (paramTerm) {
            item.terms.forEach((term) => {
              if (paramTerm === term.term_id.toString()) {
                term.selected = true;
                q_term += `&${item.taxonomy}=${term.term_id.toString()}`;
                q_tax = item.taxonomy;
                q_term_id = term.term_id.toString();
                item.selected_term = term.name;
                temp_selected_term = term.name;
              }
            });
          }
        });
      }

      // console.log("filters", filters.list);

      // TODO: Set up initial dropdown label
      if (temp_selected_term) {
        main.querySelector(".post-filter-trigger").classList.add("filtered");
        main.querySelector(".post-filter-trigger .label").innerHTML =
          temp_selected_term;
        main.querySelector(".post-filter-clear-trigger").classList.add("show");
      }

      // call inital posts
      getPosts();

      // set up observer for load more
      // setTimeout(() => {
      //   setIntersectionObserver();
      // }, 1000);
    };

    /**
     * get posts by filters
     * isPopped = call from popstate event
     */
    const getPosts = (isLoadMore = false, isPopped = false) => {
      if (!isLoadMore) {
        page.value = 1;
        isLoadCompleted = false;
      }

      api_call_status.value = 1;

      const query_string = `?post_type=${posttype.value}${q_term}&ppp=${ppp}&search=${q_search}&order=${q_order}&orderby=${q_orderby}&page=${page.value}`;

      // console.log("query_string", query_string);

      getData(`/wp-json/api/get-posts/${query_string}`).then((data) => {
        totalpages.value = data.results.totalpages;
        posts.list = isLoadMore
          ? posts.list.concat(data.results.posts)
          : data.results.posts;

        api_call_status.value = 0;

        // console.log(data.results);

        // update view (lam vs archive)
        if (q_search) {
          main.classList.remove("template-view");
          main.classList.add("archive-view");
          headline.value = `Search results for<br>&lsquo;${q_search}&rsquo;`;
          description.value = `<b>${data.results.found_posts}</b> Results`;
        } else {
          if (q_term !== "") {
            // show LAM
            main.classList.remove("template-view");
            main.classList.add("archive-view");
            headline.value = data.results.term_name;
            description.value = `<p>${data.results.term_description}</p>`;
          } else {
            // show archive
            main.classList.add("template-view");
            main.classList.remove("archive-view");
            headline.value = parse_cms.lam.headline;
            description.value = parse_cms.lam.description;
          }
        }
      });

      //
      let s_query = q_term.slice(1);
      parsedURL.search = `${s_query}`;
      history.replaceState({}, "", parsedURL);

      // push state for every query
      // if (!isPopped) {
      //   let s_query = q_term.slice(1);
      //   let s_taxonomy = s_query != "" ? s_query.split("=")[0] : "";
      //   let s_term_id = s_query != "" ? s_query.split("=")[1] : "";
      //   s_query = s_query.length > 0 ? `?${s_query}` : "";

      //   history.pushState(
      //     { taxonomy: s_taxonomy, term_id: s_term_id },
      //     "",
      //     `${window.location.origin}${window.location.pathname}${s_query}`
      //   );
      // }
    };

    /**
     * terms
     */
    const updateTerms = (cbx) => {
      q_term = "";
      q_term_id = "";
      q_tax = "";
      // console.log("checkbox", cbx); // {taxonomy: 'asset-class', term_id: 23, selected: true}

      // const targetTaxonomy = filters.list.find(
      //   (item) => item.taxonomy === cbx.taxonomy
      // );

      // console.log("targetTaxonomy", targetTaxonomy)

      // if (targetTaxonomy) {
      //   targetTaxonomy.terms.forEach((term) => {
      //     term.selected =
      //       cbx.selected && term.term_id === cbx.term_id ? true : false;
      //   });
      // }

      // filters.list.forEach((item) => {
      //   const selected_terms = [];
      //   item.terms.forEach((term) => {
      //     if (term.selected) {
      //       selected_terms.push(term.term_id);
      //     }
      //   });

      //   if (selected_terms.length > 0) {
      //     q_term += `&${item.taxonomy}=${selected_terms.toString()}`;
      //   }
      // });

      if (cbx.selected) {
        q_term = `&${cbx.taxonomy}=${cbx.term_id.toString()}`;
        q_tax = cbx.taxonomy;
        q_term_id = cbx.term_id.toString();
      } else {
        q_term = "";
        q_tax = "";
        q_term_id = "";
      }

      getPosts();
    };

    /**
     * reset terms
     */
    const resetTerms = (v) => {
      q_term = "";

      const targetTaxonomy = filters.list.find(
        (item) => item.taxonomy === v.taxonomy
      );

      // set all term to false
      if (targetTaxonomy) {
        targetTaxonomy.terms.forEach((term) => {
          term.selected = false;
        });
      }

      filters.list.forEach((item) => {
        const selected_terms = [];
        item.terms.forEach((term) => {
          if (term.selected) {
            selected_terms.push(term.term_id);
          }
        });

        if (selected_terms.length > 0) {
          q_term += `&${item.taxonomy}=${selected_terms.toString()}`;
        }
      });

      getPosts();
    };

    /**
     * search
     */
    const updateSearch = (s) => {
      q_search = s;
      getPosts();
    };

    /**
     * sort
     */
    const updateSort = (order, orderby) => {
      q_order = order;
      q_orderby = orderby;
      getPosts();
    };

    const clearFilters = () => {
      q_search = "";
      q_term = "";
      q_orderby = "date";
      q_order = "DESC";

      filters.list.forEach((item) => {
        item.terms.forEach((term) => {
          term.selected = false;
        });
      });

      getPosts();
    };

    /**
     * get posts by load more button
     */
    const getLoadMorePosts = () => {
      page.value++;

      if (page.value <= totalpages.value) {
        getPosts(true);
      } else {
        isLoadCompleted = true;
      }
    };

    return {
      filters,
      posts,
      posttype,
      headline,
      description,
      linkedin,
      instagram,
      youtube,
      page,
      totalpages,
      q_search,
      api_call_status,
      getPosts,
      updateTerms,
      resetTerms,
      updateSearch,
      updateSort,
      clearFilters,
      getLoadMorePosts,
    };
  },
};
</script>
